import { priceZodSchema, type Price } from "@@/shared/prices/price";
import { z } from "zod";

type LegacyFees = {
    serviceFee: Price;
    shipmentFee: Price;
    extraOrderFee: Price;
};
const legacyFeesZodSchema: z.ZodSchema<LegacyFees> = z.object({
    serviceFee: priceZodSchema,
    shipmentFee: priceZodSchema,
    extraOrderFee: priceZodSchema,
});
export { legacyFeesZodSchema };
export type { LegacyFees };
